module.exports = __webpack_public_path__ + "img/center-intro-structure4-1.39e0b5d9.png";